<div
  [ngClass]="params?.data?.originalValue?.[params.colDef.field]?.value !== value ? 'edited' : ''"
  class="cell-renderer-text">
  <div>{{ value }}</div>
  @if (params?.data?.originalValue?.[params.colDef.field]?.value !== value && !params?.data?.disabled && areArraysEqual()) {
    <app-icon-backspace-outline
      (click)="onUndoChangesClick()"
      [tooltip]="'Previous Value = ' +params?.data?.originalValue[params.colDef.field].value">
    </app-icon-backspace-outline>
  }
</div>

